import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'

import customizationData from '@data/customization.json'
import { getBasicShopifyOrderFront } from '@lib/operations/orders'
import type { ShopifyBasicOrderWithSubscription } from '@lib/queries/orders/get-basic-orders-query'
import { parseCustomizationPreviewParams } from '@lib/customization/preview-params'

import CustomizationPage from '@components/profile/Customization/CustomizationPage'
import AccountLayout from '@components/profile/layout/AccountLayout'
import Spinner from '@components/Spinner'
import useSubscriptions from '@lib/subscription-box/use-subscriptions'

export default function Page() {
	const pageTitle = customizationData.title[0].text
	const router = useRouter()
	const [loading, setLoading] = useState(false)
	const [initialOrder, setInitialOrder] = useState<ShopifyBasicOrderWithSubscription | null>(null)
	const { activeSubscriptions, cancelledSubscriptions } = useSubscriptions()

	const previewConfig = router.isReady ? parseCustomizationPreviewParams(router.query) : null

	useEffect(() => {
		const handleOrderRetrieval = async () => {
			const { orderId } = router.query

			if (orderId) {
				try {
					setLoading(true)
					const order = await getBasicShopifyOrderFront([orderId as string])
					if (order && order.length > 0) {
						const subscriptionSKU =
							order[0].lineItems.nodes.find((item) => !!item.sellingPlan?.sellingPlanId)?.sku || null
						setInitialOrder({
							...order[0],
							subscriptionSKU
						})
					}
				} catch (error) {
					console.error('Failed to retrieve order:', error)
				} finally {
					setLoading(false)
				}
			}
		}

		if (router.isReady) {
			handleOrderRetrieval()
		}
	}, [router.isReady, router.query])

	if (loading) {
		return (
			<div className="fixed inset-0 z-50 flex items-center justify-center bg-white/50 pointer-events-none">
				<Spinner />
			</div>
		)
	}

	return (
		<>
			<NextSeo title={pageTitle} />
			<CustomizationPage
				initialOrder={initialOrder}
				activeSubscriptions={activeSubscriptions}
				cancelledSubscriptions={cancelledSubscriptions}
				previewConfig={previewConfig}
			/>
		</>
	)
}

Page.Layout = AccountLayout
